import React from 'react';
import { RouteProps } from 'react-router-dom';
import { LayoutRoute, LayoutRouteProps } from './LayoutRoute';

export const PrivateRoute: React.FC<RouteProps & LayoutRouteProps> = (props) => <LayoutRoute {...props} privateRoute />;
